import React, { useMemo } from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import groupEvents from './eventFactory';

import { NodeEvent } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewEventsUpcomingProps {
  entities: Immutable.List<ImmutableEntity<NodeEvent>>;
  showAllOccurrences?: boolean,
}

const ViewEventsUpcoming: React.FC<ViewEventsUpcomingProps> = ({
  entities,
  showAllOccurrences,
}) => {
  const groupedEvents = useMemo(
    () => groupEvents({ events: entities, showAllOccurrences }),
    [entities, showAllOccurrences],
  );

  return (
    <div className="ViewEventsUpcoming">
      {Object.entries(groupedEvents).map(
        ([year, months]) => (
          <>
            <h2>{year}</h2>
            {Object.entries(months).map(
              ([month, events]) => (
                <>
                  <h2>{month}</h2>
                  {events.map((event: ImmutableEntity<NodeEvent>) => {
                    const eventJS = event.toJS();

                    const id = eventJS.nid[0].value;
                    const uuid = eventJS.uuid[0].value;
                    const langcode = eventJS.langcode[0].value;
                    const key = `${uuid}:${langcode}`;

                    return (
                      <Node
                        key={key}
                        id={id}
                        entity={event}
                      />
                    );
                  })}
                </>
              ),
            )}
          </>
        ),
      )}
    </div>
  );
};

export default ViewEventsUpcoming;
